
import IllustrationArmDinkyBag from '@core/illustrations/IllustrationArmDinkyBag.svg'
import IllustrationDango from '@core/illustrations/IllustrationDango.svg'
import RecommendedProductsBlock from '@recommendation/components/RecommendedProductsBlock.vue'

export default {
  components: {
    IllustrationArmDinkyBag,
    IllustrationDango,
    RecommendedProductsBlock,
  },

  props: {
    category: {
      type: String,
      required: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    clearedBody: {
      type: String,
      default: null,
    },
    clearedTitle: {
      type: String,
      default: null,
    },
    isCentered: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 12,
    },
    trackingList: {
      type: String,
      required: true,
    },
    scope: {
      type: String,
      required: true,
    },
    scopeId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    withAddToCart: {
      type: Boolean,
      default: true,
    },
    withErrorState: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      cleared: false,
      error: false,
    }
  },

  computed: {
    shouldDisplayRecommendations() {
      return !this.error && !this.cleared
    },

    shouldDisplayErrorState() {
      return this.error && this.withErrorState
    },

    shouldDisplayClearedState() {
      return this.cleared
    },
  },

  methods: {
    onCleared() {
      this.cleared = true
    },
    onError() {
      this.error = true
    },
  },
}
